/**
 * Compose overrides in the canonical runtime precedence order.
 *
 * Serialized values establish the document base. Runtime behavior overlays
 * are applied afterwards, from an outer owner to the current layer owner.
 */
export function mergeRuntimeParamOverrides(
  inheritedSerialized: Record<string, unknown>,
  nodeSerialized: Record<string, unknown>,
  inheritedRuntime: Record<string, unknown>,
  ownerRuntime: Record<string, unknown>,
): Record<string, unknown> {
  return {
    ...inheritedSerialized,
    ...nodeSerialized,
    ...inheritedRuntime,
    ...ownerRuntime,
  };
}
